import React from 'react'
import styled from 'styled-components'
import partition from 'lodash/partition'
import LinkHandler from '../utils/LinkHandler'
import { SIZES } from '../../constants'

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  background-color: #F2F3F8;
  background-repeat: no-repeat;
  border-radius: 8px;
  box-sizing: border-box;
  font-family: Roboto, sans-serif;
  color: #000000;
  font-size: 14px;
  margin-bottom: 20px;
  padding-top: 13px;
  overflow: hidden;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 82px;
    height: 83px;
    display: block;
    background-image: url('${STATICS_PATH}images/plague/background.jpg');
    background-position: 0 0;
    z-index: 1;
  }

  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    margin-top: 20px;
  }

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {

    &:before {
      transform: scaleX(-1);
      opacity: .3;
      right: 0;
      left: auto;
    }
  }

`

const MainBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 0 85px;
  align-items: flex-end;
  padding-bottom: 8px;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    margin: 0 24px;
    position: relative;
    z-index: 2;
  }
`

const MainBoxFirstItem = styled.div`
  flex: 0 0 30%;

  @media (max-width: ${SIZES.BREAKPOINT_SM - 1}px) {
    flex: 0 0 100%;
  }
`
const MainBoxItem = styled.div`
  flex: 0 0 70%;
  padding-left: 63px;

  @media (max-width: ${SIZES.BREAKPOINT_SM - 1}px) {
    padding-top: 13px;
    flex: 0 0 100%;
    padding-left: 0;
  }
`

const DataLink = styled.span`
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  color: #2F6894;
  flex: 0 0 100%;
  margin-top: 5px;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    font-size: 13px;
  }
`

const MainBoxItemLink = styled.a`
  color: inherit;
  text-decoration: none;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    color: inherit;
    text-decoration: none;
  }

  @media (max-width: ${SIZES.BREAKPOINT_SM - 1}px) {
    flex: 0 0 100%;
    justify-content: flex-start;
  }
`

const InformationLink = styled.a`
  font-weight: bold;
  font-size: 32px;
  line-height: 32px;
  color: #000000;
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;

  &:hover {
    color: #000000;
    text-decoration: none;
  }

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    font-size: 21px;
  }
`

const Articles = styled.ul`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  border-top: 1px dashed #D2D2D2;
  font-weight: normal;
  font-size: 13px;
  line-height: 20px;
  margin: 0 24px;
  padding-bottom: 16px;
  padding-inline-start: 0px;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    padding-right: 20px;
    padding-bottom: 5px;
  }
`

const Article = styled.li`
  padding: 6px 0 0;
  margin-left: 16px;
  font-size: 12px;
  line-height: 17px;
  flex: 0 0 30%;
  font-style: normal;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    padding-bottom: 13px;
    flex: 0 0 100%;
  }
`

const ArticleLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
  }
`

const ArticleText = styled.p`
  overflow: hidden;
  margin-bottom: 0;
  display: inline;
`

const DataWrapper = styled.div`
  text-align: center;
  position: relative;
  display: flex;
  flex: 0 0 100%;
  flex-wrap: nowrap;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    flex-wrap: wrap;
  }
`

const DataItem = styled.div`
  display: block;
  flex: 0 0 25%;
  text-align: left;
  box-sizing: border-box;
  color: #000000;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    flex: 0 0 50%;
    margin-bottom: 13px;
  }
`

const DataNumber = styled.h3`
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 0;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    font-size: 17px;
  }
`

const HealthyNumber = styled.span`
  color: ${props => props.theme.coronaHighlight.color}; 
`

const DataKey = styled.em`
  font-weight: normal;
  font-size: 12px;
  line-height: 24px;

  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    font-size: 11px;
  }
`

export default (props) => {
  const {
    widget: {
      utmSource,
      utmMedium,
      boxes
    }
  } = props
  const mainBoxUrl = 'https://zpravy.aktualne.cz/domaci/pocty-nakazenych-v-krajich/r~c68291be683f11ea9d74ac1f6b220ee8/'
  const mainBoxLink = new LinkHandler(mainBoxUrl).mergeUTMParams({ utmSource, utmMedium, utmContent: 'covid' }).link
  const informationButtonUrl = 'https://zpravy.aktualne.cz/widget-koronavirus-vse-o-koronaviru/r~28c952346d0611eaa6f6ac1f6b220ee8/'
  const informationButtonLink = new LinkHandler(informationButtonUrl).mergeUTMParams({ utmSource, utmMedium, utmContent: 'covid' }).link
  const [ articles, [ stats ] ] = partition(boxes, { source: 'BbxCoronavirus' })

  return (
    <Wrapper>
      <MainBox>
        <MainBoxFirstItem>
          <InformationLink href={informationButtonLink}>
            Vše důležité o koronaviru
            <DataLink>
              Grafy, přehledy, rady »
            </DataLink>
          </InformationLink>
        </MainBoxFirstItem>
        <MainBoxItem>
          <MainBoxItemLink href={mainBoxLink} target="_blank">
            <DataWrapper>
              <DataItem>
                <DataKey>Testů</DataKey>
                <DataNumber>{ stats.countTest }</DataNumber>
              </DataItem>
              <DataItem>
                <DataKey>Nakažených</DataKey>
                <DataNumber>{ stats.countSick }</DataNumber>
              </DataItem>
              <DataItem>
                <DataKey>Uzdravených</DataKey>
                <DataNumber><HealthyNumber>{ stats.countRecover }</HealthyNumber></DataNumber>
              </DataItem>
              <DataItem>
                <DataKey>Úmrtí</DataKey>
                <DataNumber>{ stats.countDead }</DataNumber>
              </DataItem>
            </DataWrapper>
            <DataLink>
              Počty nakažených v ČR podle krajů a další statistiky »
            </DataLink>
          </MainBoxItemLink>
        </MainBoxItem>
      </MainBox>
      <Articles>
        {
          articles.map(({ link, images, title }, index) => (
            <Article key={index}>
              <ArticleLink href={new LinkHandler(link).mergeUTMParams({ utmSource, utmMedium, utmContent: 'covid' }).link}>
                <ArticleText>{title}</ArticleText>
              </ArticleLink>
            </Article>
          ))
        }
      </Articles>
    </Wrapper>
  )
}
